import { Edge } from "../types";

export function regionalizeIceUrls(edge: Edge, iceServers: RTCIceServer[]) {
    if (edge === 'roaming') {
        return iceServers;
    }

    return iceServers.map((server: RTCIceServer) => {
        const result = {
            ...server,
        };

        if (result.url) {
            result.url = result.url.replace('global', edge);
        }

        if (typeof result.urls === 'string') {
            result.urls = result.urls.replace('global', edge);
        }

        if (Array.isArray(result.urls)) {
            result.urls = result.urls.map((url) => url.replace('global', edge));
        }
        return result;
    });
}